import React, { memo } from 'react';

import Box from '../../components/Box';

interface Props {}

const Index: React.FC<Props> = memo(() => {
  return (
    <Box>
      <h1 className="text-2xl font-bold mb-4">Welcome to the Home Page</h1>
      <p className="mb-4">
        Use the navigation above to visit the Squiggles and Blocks pages.
      </p>
    </Box>
  );
});
Index.displayName = 'Index';

export default Index;
